export default function SvgExit() {
    return (
      <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        width="20px"
        cursor="pointer"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 64 64"
    >
        <path id="Icons" fill="none" d="M-192-320h1280v800H-192z"></path>
        <g id="Icons1">
        <g id="turn-off">
            <path d="M40 14.62c7.91 3.16 13.505 10.896 13.505 19.928 0 11.838-9.611 21.449-21.449 21.449s-21.449-9.611-21.449-21.449c0-8.99 5.542-16.695 13.393-19.883v4.332c-5.616 2.918-9.456 8.789-9.456 15.551 0 9.665 7.847 17.512 17.512 17.512s17.512-7.847 17.512-17.512c0-6.806-3.891-12.711-9.568-15.608z"></path>
            <path d="M34.056 9.886a2 2 0 0 0-4 0v24a2 2 0 0 0 4 0z"></path>
        </g>
        </g>
    </svg>
    </>
    );
  }